import { payload as batchActionPayload } from '@/components/RouteComponents/Batches/actionPayload'

export default function (store, trx) {
  const { getBatchById, getCurrentPeriod } = store.getters
  const batchExists = getBatchById(trx.batch) && Object.keys(getBatchById(trx.batch)).length
  const periodExists = getCurrentPeriod && Object.keys(getCurrentPeriod).length
  let promises = []
  if (!periodExists) {
    promises.push(store.dispatch('fetchPeriodsWithQuery', { active: 'True' }))
  }
  if (!batchExists) {
    const payload = Object.assign({}, batchActionPayload, { query: { active: 'True' } })
    promises.push(store.dispatch('fetchWithQuery', payload))
  }
  return promises
}



// WEBPACK FOOTER //
// ./src/utils/helpers/DataEntryViews/FindOrFetchBatchAndPeriod.js